import { FetchResult } from "configcat-common";
var HttpConfigFetcher = /** @class */ (function () {
    function HttpConfigFetcher() {
    }
    HttpConfigFetcher.prototype.fetchLogic = function (options, _lastEtag, callback) {
        var httpRequest = new XMLHttpRequest();
        httpRequest.onreadystatechange = function () {
            if (httpRequest.readyState === 4) {
                var etag = httpRequest.getResponseHeader("ETag") || "";
                if (httpRequest.status === 200) {
                    callback(FetchResult.success(httpRequest.responseText, etag));
                }
                else if (httpRequest.status === 304) {
                    callback(FetchResult.notModified());
                }
                else {
                    options.logger.error("Failed to download feature flags & settings from ConfigCat. ".concat(httpRequest.status, " - ").concat(httpRequest.statusText));
                    callback(FetchResult.error());
                }
            }
        };
        httpRequest.open("GET", options.getUrl(), true);
        httpRequest.timeout = options.requestTimeoutMs;
        httpRequest.send(null);
    };
    return HttpConfigFetcher;
}());
export { HttpConfigFetcher };
